import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

// Always include Bearer token if we have one in localStorage as a fallback
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("s2s_token");
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function formatApiError(e) {
    const detail = e?.response?.data?.detail;
    if (detail == null) return e?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
